import Tooltip from '@/components/common/Tooltip';
import { ADDITIONAL_REQUEST_PAYMENT_TYPE, DISPPLAY_MOMENT_YMD_HM, PAYMENT_HISTORY_STATUS_DATA, PAYMENT_TYPE_OBJECT, REFUND_STATUS_DATA } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import { DOWNLOAD_TYPE, DownloadType, ORDER_STATUS, OrderStatusType, PAYMENT_HISTORY_STATUS, PAYMENT_METHOD, PAYMENT_TYPE, ROLE_ADMIN, ROLE_OWNER } from '@/types/enums';
import { ReservationInformation, ReservationDetailItem, PaymentHistoryItem, ReservationCustomerInfor } from '@/types/reservation';
import { formatCurrency } from '@/utils/formatNumber';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TransactionHistory from '../modal/TransactionHistory';
import { ButtonCus, ButtonCusWithIcon } from '@/components/common/Button';
import CancelOrder from '../modal/CancelOrder';
import RequestCancel from '../modal/RequestCancel';
import UpdateCancelOrder from '../modal/UpdateCancelOrder';
import PaymentRequestAries from '../modal/PaymentRequestAries';
import { ColumnDef } from '@tanstack/react-table';
import Table from '@/components/table/Table';
import { formatDateTime } from '@/utils/datetime';
import { isRoles } from '@/utils/utils';
import { InvoiceIcon, ReceiptIcon, TransactionIcon } from '@/components/icon/bill-icons';
import RequestUpdateOrder from '../modal/RequestUpdateOrder';
import { ICON_IDS } from '@/constants/icon';
import IssueInvoiceFormRentalHistory from '@/pages/my-account/rental-history-tab/list/component/IssueInvoiceFormRentalHistory';

interface PaymentInforProps {
    reservation: ReservationDetailItem,
    isForEnd?: boolean
}
export default observer(function PaymentInfor({ reservation, isForEnd = false }: PaymentInforProps) {
    // hooks
    const { t: tAll } = useTranslation();
    const { t } = useTranslation('transation', { keyPrefix: 'field' });
    const { t: tButton } = useTranslation('transaltion', { keyPrefix: 'button' });
    const isOwner = isRoles([...ROLE_OWNER]);
    const isAdmin = isRoles([...ROLE_ADMIN]);

    // store
    const {
        modalStore: { showModal, showAlertModal },
        reservationStore: { paymentHistory, getPaymentHistory, getReservationCMSDetail, getReservationENDDetail }
    } = useStore();

    const { information: infor = {} as ReservationInformation, renter = {} as ReservationCustomerInfor } = reservation || {};
    const { payment, orderStatus, cancelInfor, refundInfor, id } = infor;

    const accpetCancelButton: OrderStatusType[] = [ORDER_STATUS.Not_Paid, ORDER_STATUS.Paid];
    const accpetRequestCancelButton: OrderStatusType[] = [ORDER_STATUS.Not_Paid, ORDER_STATUS.Paid, ORDER_STATUS.Add_Not_Paid];
    const accpetRequsetUpdateButton: OrderStatusType[] = [ORDER_STATUS.Not_Paid, ORDER_STATUS.Paid, ORDER_STATUS.Add_Not_Paid];

    // state
    const [acceptDownloadInvoice, acceptDownloadReceipt] = useMemo(() => {
        let acceptedInvocie = false;
        let acceptedReceipt = false;
        if (paymentHistory && paymentHistory.length > 0) {
            acceptedInvocie = paymentHistory.some(item => [PAYMENT_TYPE.UPDATE_ORDER, PAYMENT_TYPE.OTHER].includes(item.paymentType));
            acceptedReceipt = paymentHistory.every(payment => payment.paymentStatus === PAYMENT_HISTORY_STATUS.PAIDED);
            // let paymentAdditionalOfOrder = paymentHistory.filter(payment => [PAYMENT_TYPE.OTHER].includes(payment.paymentType));
            // if (paymentAdditionalOfOrder.length > 0) {
            //     acceptedReceipt = paymentAdditionalOfOrder.every(payment => payment.paymentStatus === PAYMENT_HISTORY_STATUS.PAIDED);
            // }
        }

        if (payment?.paymentMethodVal === PAYMENT_METHOD.VISUAL_TRANSFER) {
            acceptedInvocie = true;
        }

        return [acceptedInvocie, acceptedReceipt];
    }, [paymentHistory, reservation]);

    // function

    const onClickDownloadInvoice = async (id: number) => {
        handleOpenModal(infor, DOWNLOAD_TYPE.INVOICE);
        // await flowResult(downloadInvoice({ id }));
    };

    const onClickDownloadReceipt = async (id: number) => {
        handleOpenModal(infor, DOWNLOAD_TYPE.RECEIPT);
        // await flowResult(downloadReceipt({ id }));
    };

    const onClickViewTransaction = (id: number) => {
        showModal({
            id: 'transaction-history',
            title: tAll('words_title.transaction_history'),
            size: '4xl',
            titleClassName: 'text-center',
            contentClassName: 'max-w-full overflow-x-auto',
            content: (
                <TransactionHistory
                    orderId={id}
                />
            ),
            footerClassName: 'hidden'
        });
    };

    const handleOpenModal = (item: any, type: DownloadType) => {
        const idModal = 'issue-invoice-modal';
        let data = {
            id: item.id,
            renter: {
                id: renter.id,
                fullName: renter.fullname
            },
            acceptDownloadReceipt
        };
        showAlertModal({
            id: idModal,
            // title: t('words_title.rental_bike_fee_table_issued'),
            title: type === DOWNLOAD_TYPE.RECEIPT ? '領収書発行' : '請求書発行',
            size: '2xl',
            titleClassName: 'text-center max-w-none',
            content: (
                <IssueInvoiceFormRentalHistory idModal={idModal} adjust={data} type={type} isAdmin={isAdmin} />
            ),
            footerClassName: 'hidden'
        });
    };

    const onClickRequestCancel = (ids: number[]) => {
        showModal({
            id: 'update-reservation',
            title: tAll('words_title.request_cancel'),
            size: 'xl',
            titleClassName: 'text-center max-w-none',
            content: (
                <RequestCancel
                    orderIds={ids}
                    reload={() => {
                        getReservationCMSDetail({ id });
                        getPaymentHistory({ id });
                    }}
                />
            ),
            footerClassName: 'hidden'
        });
    };

    const onClickCancelOrder = (ids: number[]) => {
        showModal({
            id: 'update-reservation',
            title: tAll('words_title.cancel_reservation'),
            size: 'xl',
            titleClassName: 'text-center max-w-none',
            content: (
                <CancelOrder
                    orderIds={ids}
                    reload={() => {
                        !isForEnd ? getReservationCMSDetail({ id }) : getReservationENDDetail(id);
                        getPaymentHistory({ id });
                    }}
                    isForEnd={isForEnd}
                />
            ),
            footerClassName: 'hidden'
        });
    };

    const onClickUpdateRefundOrder = (id: number) => {
        showModal({
            id: 'update-reservation',
            // title: tAll('words_title.reservation_update'),
            title: tButton('update_refund'),
            size: 'xl',
            titleClassName: 'text-center max-w-none',
            content: (
                <UpdateCancelOrder
                    id={id}
                    reload={() => {
                        getReservationCMSDetail({ id });
                        getPaymentHistory({ id });
                    }}
                />
            ),
            footerClassName: 'hidden'
        });
    };

    const onClickPaymentRequestAries = (id: number) => {
        showAlertModal({
            id: 'request-payment',
            // title: tAll('words_title.reservation_update'),
            title: tButton('payment_request_arises'),
            size: '2xl',
            titleClassName: 'text-center max-w-none',
            content: (
                <PaymentRequestAries
                    id={id}
                    reload={() => {
                        getReservationCMSDetail({ id });
                        getPaymentHistory({ id });
                    }}
                />
            ),
            footerClassName: 'hidden'
        });
    };

    const onClickRequestUpdateBooking = (id: number | string) => {
        showModal({
            id: 'request-update-reservation',
            // title: tAll('words_title.reservation_update'),
            title: tAll('words_title.title_request_update_order'),
            size: 'xl',
            titleClassName: 'text-center max-w-none',
            content: (
                <RequestUpdateOrder
                    id={Number(id)}
                    reload={() => {
                    }}
                />
            ),
            footerClassName: 'hidden'
        });
    };

    // columns
    const columns: ColumnDef<PaymentHistoryItem>[] = [
        // {
        //     id: 'actions',
        //     header: '',
        //     size: 50,
        //     cell: ({ row: { original } }) => {
        //         return (
        //             <TableActionButtons
        //                 onView={() => onClickViewDetail(original.id)}
        //             />
        //         );
        //     }
        // },
        {
            accessorKey: 'createdDate',
            header: t('applied_date'),
            size: 400,
            cell: ({ row: { original } }) => (
                <div>{original?.createdDate ? formatDateTime(original.createdDate, DISPPLAY_MOMENT_YMD_HM, { useLocalTime: false }) : ''}</div>
            ),
            enableSorting: false

        },
        {
            accessorKey: 'paymentDate',
            header: t('reservation.payment_date'),
            size: 400,
            cell: ({ row: { original } }) => (
                <div className='min-w-[100px]'>{original?.paymentDate ? formatDateTime(original.paymentDate, DISPPLAY_MOMENT_YMD_HM, { useLocalTime: false }) : ''}</div>
            ),
            enableSorting: false
        },
        {
            accessorKey: 'note',
            header: t('content'),
            size: 350,
            cell: ({ row: { original } }) => (
                <div className='min-w-[100px] break-all'>
                    <span className=''>
                        {
                            [PAYMENT_TYPE.ORDER_CREATE, PAYMENT_TYPE.UPDATE_ORDER].includes(original?.paymentType) ?
                                tAll(`${PAYMENT_TYPE_OBJECT[original.paymentType].key}`) :
                                original?.paymentType === PAYMENT_TYPE.OTHER && original.additionalType ?
                                    tAll(`${ADDITIONAL_REQUEST_PAYMENT_TYPE[original.additionalType].key}`) :
                                    <></>
                        }
                    </span>
                    <span>{original.note && `: ${original.note}`}</span>
                </div>
            ),
            enableSorting: false
        },
        {
            accessorKey: 'amount',
            header: t('amount2'),
            size: 200,
            meta: {
                headerClassName: 'right-sub-header-item',
                cellClassName: ''
            },
            cell: ({ row: { original } }) => (
                <div className='text-right'>
                    {original.amount ?
                        (
                            <>
                                {tAll('currency.currency_symbol')}
                                {formatCurrency(original.amount)}
                            </>
                        ) :
                        <></>}

                </div>
            ),
            enableSorting: false
        },
        {
            accessorKey: 'status',
            header: t('status'),
            size: 400,
            enableSorting: false,
            cell: ({ row: { original } }) => (
                <div className='min-w-[100px]'>
                    {
                        (Number(original.amount) > 0 && original.paymentStatus !== PAYMENT_HISTORY_STATUS.NO_NEED_REFUNDED) &&
                        (<span className={classNames(PAYMENT_HISTORY_STATUS_DATA[original.paymentStatus].color)}>{tAll(`${PAYMENT_HISTORY_STATUS_DATA[original.paymentStatus].key}`)}</span>)
                    }
                </div>
            )
        }

    ];

    return (
        <div className='flex flex-col w-full xsm:gap-4 gap-2'>
            <h1 className='text-fs-mid18 text-black-1 font-semibold'>{tAll('words_title.payment_information')}</h1>
            <div className='grid grid-cols-1 text-text-3 gap-4 md:grid-cols-2 xsm:mt-0 mt-2'>
                <div className='flex flex-col gap-2'>
                    <div className='flex xsm:w-fit flex-col gap-2'>
                        <div className='flex gap-4 justify-between'>
                            <label className='w-40 '>
                                {t('reservation.total_amount')}
                            </label>
                            <p className='break-all'>
                                {`${tAll('currency.currency_symbol')}${formatCurrency(Number(payment?.totalAmount || 0) - Number(payment?.totalCompensation || 0)) || '0'}`}
                            </p>
                        </div>
                        {
                            payment?.totalCompensation > 0 && (
                                <div className='flex gap-4 justify-between'>
                                    <label className='w-40 '>
                                        {tAll('field.compensation')}
                                    </label>
                                    <p className='break-all'>
                                        {`${tAll('currency.currency_symbol')}${formatCurrency(payment.totalCompensation) || 0}`}
                                    </p>
                                </div>
                            )
                        }
                        {
                            payment?.totalAdditionalPayment > 0 && (
                                <div className='flex gap-4 justify-between'>
                                    <label className='w-40 '>
                                        {tAll('field.payment_other')}
                                    </label>
                                    <p className='break-all'>
                                        {`${tAll('currency.currency_symbol')}${formatCurrency(payment.totalAdditionalPayment) || 0}`}
                                    </p>
                                </div>
                            )
                        }
                        {payment?.discount?.length > 0 && (
                            payment?.discount.map((discount, index) => (
                                <div key={index} className='flex gap-4 justify-between'>
                                    <label className='w-40 '>
                                        {t('reservation.reservation_coupon')}
                                        {/* <span>{` ${index + 1}`}</span> */}
                                    </label>
                                    <p className='break-all'>
                                        &#9650;
                                        {`${tAll('currency.currency_symbol')}${formatCurrency(discount.discountAmount) || '0'}`}
                                    </p>
                                </div>
                            ))
                        )}
                        <div className='flex gap-4 border-t border-text-3 justify-between'>
                            <label className='flex-none w-40'>{t('payment')}</label>
                            <p className='break-all'>
                                {`${tAll('currency.currency_symbol')}${formatCurrency(payment?.totalPayment) || '0'}`}
                            </p>
                        </div>
                        <div className='flex gap-4 justify-between'>
                            <label className='flex-none w-40'>{t('reservation.payment_method')}</label>
                            <p className=''>{payment?.method}</p>
                        </div>
                    </div>

                    <div className={classNames('grid', !isForEnd && !isOwner ? 'grid-cols-3' : 'grid-cols-2')}>
                        {!isOwner && (
                            <>
                                <div className='flex flex-col gap-2 w-fit items-center'>
                                    <label className=''>{t('invoice')}</label>
                                    <div className='w-10 flex justify-center'>
                                        <Tooltip
                                            content={tButton('download_invoice')}
                                            triggerClassName={classNames(orderStatus === ORDER_STATUS.Cancel || !acceptDownloadInvoice ? 'cursor-not-allowed pointer-events-none' : 'cursor-pointer')}
                                        >
                                            <div
                                                onClick={() => onClickDownloadInvoice(id)}
                                                className={classNames(
                                                    'size-9 rounded-full  flex items-center justify-center transition-all ',
                                                    orderStatus === ORDER_STATUS.Cancel || !acceptDownloadInvoice ? 'bg-disable-2' : 'bg-background-4 hover:bg-gray-200'
                                                )}
                                            >
                                                <InvoiceIcon className='text-icon-4 size-5' />
                                            </div>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className='flex flex-col gap-2 w-fit items-center'>
                                    <label className=''>{t('receipt')}</label>
                                    <div className='w-10 flex justify-center'>
                                        <Tooltip
                                            content={tButton('download_receipt')}
                                            triggerClassName={classNames(acceptDownloadReceipt ? '' : 'cursor-not-allowed pointer-events-none')}
                                        >
                                            <div
                                                onClick={() => onClickDownloadReceipt(id)}
                                                className={classNames(
                                                    'size-9 rounded-full bg-background-4 flex items-center justify-center hover:bg-gray-200 transition-all',
                                                    acceptDownloadReceipt ? 'bg-background-4 hover:bg-gray-200' : 'bg-disable-2'
                                                )}
                                            >
                                                <ReceiptIcon className='text-icon-4 size-5' />
                                            </div>
                                        </Tooltip>
                                    </div>
                                </div>
                            </>
                        )}
                        {
                            !isForEnd && !isOwner && (
                                <div className='flex flex-col gap-2 w-fit items-center'>
                                    <label className=''>{tAll('words_title.transaction_history')}</label>
                                    <div className='w-10 flex justify-center'>
                                        <Tooltip content={tButton('view_transaction')}>
                                            <div
                                                onClick={() => onClickViewTransaction(id)}
                                                className='flex bg-background-4 justify-center rounded-full cursor-pointer hover:bg-gray-200 items-center size-9 transition-all'
                                            >
                                                <TransactionIcon className='text-icon-4 size-5' />
                                            </div>
                                        </Tooltip>
                                    </div>

                                </div>
                            )
                        }

                    </div>
                </div>
                <div className='flex flex-col gap-2'>
                    {
                        orderStatus === ORDER_STATUS.Cancel && (
                            <>
                                <div className='flex flex-col gap-2'>
                                    <label className='flex-none'>{t('reason_for_cancellation')}</label>
                                    <div className='bg-background-10 p-3 rounded-md text-black font-normal break-all'>
                                        {cancelInfor?.cancelReason || '--'}
                                    </div>
                                </div>
                                {/* <div className='flex gap-4'>
                                    <label className='flex-none w-40'>{t('cancel_fee')}</label>
                                    <p className='text-red-5 font-medium break-all'>
                                        {`${tAll('currency.currency_symbol')}${formatCurrency(cancelInfor?.cancelFee || '0')}`}
                                    </p>
                                </div> */}
                            </>
                        )
                    }
                    <div className='xsm:w-fit w-full flex flex-col gap-2'>
                        {
                            orderStatus === ORDER_STATUS.Cancel && (
                                <div className='flex gap-4 justify-between'>
                                    <label className='flex-none w-40'>{t('cancel_fee')}</label>
                                    <p className='text-red-5 labelSearch break-all'>
                                        {`${tAll('currency.currency_symbol')}${formatCurrency(cancelInfor?.cancelFee || '0')}`}
                                    </p>
                                </div>
                            )
                        }
                        {
                            refundInfor && (
                                <>
                                    <div className='flex gap-4 justify-between'>
                                        <label className='flex-none w-40'>{t('reservation.refund_amount')}</label>
                                        <p className='text-red-5 labelSearch break-all'>
                                            {`${tAll('currency.currency_symbol')}${formatCurrency(refundInfor?.refundFee) || '0'}`}
                                        </p>
                                    </div>
                                    <div className='flex gap-4 justify-between'>
                                        <label className='flex-none w-40'>{t('reservation.refund_status')}</label>
                                        {refundInfor.refundStatus != null ?
                                            (
                                                <div className={classNames(`${REFUND_STATUS_DATA[refundInfor.refundStatus]?.color}`, '')}>
                                                    {tAll(REFUND_STATUS_DATA[refundInfor.refundStatus]?.key)}
                                                </div>
                                            ) :
                                            <p>--</p>}
                                    </div>
                                </>
                            )
                        }
                    </div>

                </div>
            </div>
            <div className='md:mt-6 mt-4'>
                <p className='text-[1.125rem] text-black-1 font-semibold mb-4'>{t('reservation.payment_history')}</p>
                <Table
                    columns={columns}
                    data={paymentHistory}
                    showSelectPageSize={false}
                    enableRowSelection={false}
                    showPagination={false}
                    showTableFooter={false}
                    enableScrollResTable={isOwner || isForEnd}
                />
            </div>
            <div className='flex justify-center sm:flex-row flex-col mt-2 gap-4 items-center'>
                {
                    isForEnd === false && !isOwner && refundInfor?.acceptRefund === true && orderStatus === ORDER_STATUS.Cancel && (
                        <ButtonCus
                            variant='default'
                            size='md'
                            type='button'
                            onClick={() => onClickUpdateRefundOrder(id)}
                        >
                            {tButton('update_refund')}
                        </ButtonCus>
                    )
                }
                {
                    !isOwner && !isForEnd && orderStatus === ORDER_STATUS.Return && (
                        <ButtonCus onClick={() => onClickPaymentRequestAries(id)} size='md' variant='green'>{tButton('payment_request_arises')}</ButtonCus>
                    )
                }
                {
                    isOwner && accpetRequestCancelButton.includes(orderStatus) && (
                        <ButtonCus
                            variant='default'
                            size='md'
                            type='button'
                            onClick={() => {
                                onClickRequestCancel([id]);
                            }}
                        >
                            {t('reservation.request_cancel')}
                        </ButtonCus>

                    )
                }
                {
                    isForEnd && accpetCancelButton.includes(orderStatus) && (
                        <ButtonCusWithIcon
                            variant='default'
                            size='md'
                            type='button'
                            onClick={() => {
                                onClickCancelOrder([id]);
                            }}
                            iconId={ICON_IDS.DELETE}
                        >
                            {t('reservation.cancel_order')}
                        </ButtonCusWithIcon>
                    )
                }
                {
                    accpetRequsetUpdateButton.includes(orderStatus) && isForEnd && (
                        <ButtonCusWithIcon
                            variant='green2'
                            size='md'
                            type='button'
                            onClick={() => {
                                onClickRequestUpdateBooking(id);
                            }}
                            iconId={ICON_IDS.MESSAGE}
                            heightIcon={20}
                            widthIcon={20}
                        >
                            {tButton('request_update_booking')}
                        </ButtonCusWithIcon>
                    )
                }
            </div>
        </div>
    );
});
